import LaiaAccountForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    LaiaAccountForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('laiaAccounts.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.laiaAccounts.show(this.$route.params.id).then(response => {
        this.data = JSON.parse(JSON.stringify(response))
        this.ready = true

        this.$setBreadcrumbs([
          {label: this.$t('breadcrumbs.laiaAccounts.index'), route: {name: 'accounts-laia-index'}},
          {label: this.$t('breadcrumbs.laiaAccounts.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateCallCenter(data) {
      API.laiaAccounts.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('laiaAccounts.edit.succesfullyUpdated'))
        this.$router.push({name: 'accounts-laia-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
